import { NamedColumn, SqlOptions } from '../types';

export function findColumn(
  sqlOptions: SqlOptions,
  key: string,
): NamedColumn | null {
  const formColumns = sqlOptions.queryColumns.form;

  for (let x = 0; x < formColumns.length; x += 1) {
    const column = formColumns[x];
    const { field, name } = column;
    const cleanKey = getCleanKey(key);

    if (cleanKey === field || cleanKey === name || `_${cleanKey}` === name) {
      return {
        ...column,
        identifier: () => field || name,
      };
    }
  }
  return null;
}

function specialTranslation(key: string): string | null {
  switch (key) {
    case 'project':
    case 'created_by':
    case 'assigned_to':
      return `${key}.name`;
    default:
      return null;
  }
}

function getCleanKey(key: string) {
  if (key.toLowerCase().startsWith('form_values.')) {
    return key.split('.')[1];
  }

  return key;
}

export function findColumnName(
  sqlOptions: SqlOptions,
  key: string,
): string | null {
  const translation = specialTranslation(key);
  if (translation) {
    return translation;
  }

  const queryColumn = findColumn(sqlOptions, key);
  if (queryColumn) {
    return queryColumn.identifier();
  }

  return null;
}
